import { Link as RouterLink } from "@tanstack/react-router";
// Components
import { AddToNewOrderBtn } from "./AddToNewOrderBtn";
import { ComponentAuthorisation } from "../../components/ComponentAuthorisation";
import { useBulkOrderMode } from "../../hooks/useAuthorisation";
// MUI
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

export const StaffListHeader = ({ status, selectedRows }) => {
  const bulkOrderMode = useBulkOrderMode();
  let heading = "All Staff";
  if (status === "active") {
    heading = "Active Staff";
  } else if (status === "inactive") {
    heading = "Inactive Staff";
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        pb: 1,
      }}
    >
      <Typography variant="h5">{heading}</Typography>
      <Stack direction="row" spacing={2}>
        {!bulkOrderMode && (
          <ComponentAuthorisation allowedRoles={["alloworders"]}>
            <AddToNewOrderBtn selectedRows={selectedRows} />
          </ComponentAuthorisation>
        )}

        <ComponentAuthorisation allowedRoles={["staffCreate"]}>
          <Button variant="outlined" component={RouterLink} to="/staff/add">
            Add Staff
          </Button>
        </ComponentAuthorisation>
      </Stack>
    </Stack>
  );
};
